import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _detectRangeSettings;

export var TOLERANCE_LEVEL = {
  SATISFIES: 0,
  RECOMMEND: 1,
  FORBIDDEN: 2
};
export var detectRangeSettings = (_detectRangeSettings = {}, _defineProperty(_detectRangeSettings, TOLERANCE_LEVEL.SATISFIES, {
  chrome: '>=80',
  firefox: '>=80',
  safari: '>=12'
}), _defineProperty(_detectRangeSettings, TOLERANCE_LEVEL.RECOMMEND, {
  chrome: '>=80',
  firefox: '>=80',
  safari: '>=12'
}), _defineProperty(_detectRangeSettings, TOLERANCE_LEVEL.FORBIDDEN, {
  chrome: '>=80',
  firefox: '>=80',
  safari: '>=12'
}), _detectRangeSettings);
export var BROWSER_FULLY_FUNCTIONAL_RANGE = {
  chrome: '>=88',
  firefox: '>=85',
  safari: '>=13'
};
export var BROWSER_RECOMMEND_UPGRADE_RANGE = {
  chrome: '>=80',
  // [80, 88)
  firefox: '>=80',
  // [80, 85)
  safari: '>=12' // [12, 13)

};